export default __webpack_public_path__ + "static/eds-map-1-e36fddce6e119052aeb362ae2d5b304b.gif";